module.exports = __webpack_public_path__ + "static/media/ApruebaDeNuevo.e98b7627.mp3";